import { validateStaticEnvVars } from "./env-config.schema";

/** @deprecated use publicConfig from useServices hook instead */
export const browserEnvConfig = validateStaticEnvVars({
  NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
  NEXT_PUBLIC_STATS_APP_URL: process.env.NEXT_PUBLIC_STATS_APP_URL,
  NEXT_PUBLIC_PROVIDER_PROXY_URL: process.env.NEXT_PUBLIC_PROVIDER_PROXY_URL,
  NEXT_PUBLIC_DEFAULT_NETWORK_ID: process.env.NEXT_PUBLIC_DEFAULT_NETWORK_ID,
  NEXT_PUBLIC_MASTER_WALLET_ADDRESS: process.env.NEXT_PUBLIC_MASTER_WALLET_ADDRESS,
  NEXT_PUBLIC_UAKT_TOP_UP_MASTER_WALLET_ADDRESS: process.env.NEXT_PUBLIC_UAKT_TOP_UP_MASTER_WALLET_ADDRESS,
  NEXT_PUBLIC_USDC_TOP_UP_MASTER_WALLET_ADDRESS: process.env.NEXT_PUBLIC_USDC_TOP_UP_MASTER_WALLET_ADDRESS,
  NEXT_PUBLIC_MANAGED_WALLET_NETWORK_ID: process.env.NEXT_PUBLIC_MANAGED_WALLET_NETWORK_ID,
  NEXT_PUBLIC_DEFAULT_INITIAL_DEPOSIT: process.env.NEXT_PUBLIC_DEFAULT_INITIAL_DEPOSIT,
  NEXT_PUBLIC_TRIAL_DEPLOYMENTS_DURATION_HOURS: process.env.NEXT_PUBLIC_TRIAL_DEPLOYMENTS_DURATION_HOURS,
  NEXT_PUBLIC_TRIAL_CREDITS_AMOUNT: process.env.NEXT_PUBLIC_TRIAL_CREDITS_AMOUNT,
  NEXT_PUBLIC_TRIAL_DURATION_DAYS: process.env.NEXT_PUBLIC_TRIAL_DURATION_DAYS,
  NEXT_PUBLIC_NODE_ENV: process.env.NEXT_PUBLIC_NODE_ENV,
  NEXT_PUBLIC_BASE_API_MAINNET_URL: process.env.NEXT_PUBLIC_BASE_API_MAINNET_URL,
  NEXT_PUBLIC_BASE_API_TESTNET_URL: process.env.NEXT_PUBLIC_BASE_API_TESTNET_URL,
  NEXT_PUBLIC_BASE_API_SANDBOX_URL: process.env.NEXT_PUBLIC_BASE_API_SANDBOX_URL,
  NEXT_PUBLIC_REDIRECT_URI: process.env.NEXT_PUBLIC_REDIRECT_URI,
  NEXT_PUBLIC_GITHUB_APP_INSTALLATION_URL: process.env.NEXT_PUBLIC_GITHUB_APP_INSTALLATION_URL,
  NEXT_PUBLIC_BITBUCKET_CLIENT_ID: process.env.NEXT_PUBLIC_BITBUCKET_CLIENT_ID,
  NEXT_PUBLIC_GITLAB_CLIENT_ID: process.env.NEXT_PUBLIC_GITLAB_CLIENT_ID,
  NEXT_PUBLIC_GITHUB_CLIENT_ID: process.env.NEXT_PUBLIC_GITHUB_CLIENT_ID,
  NEXT_PUBLIC_GA_MEASUREMENT_ID: process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID,
  NEXT_PUBLIC_GA_ENABLED: process.env.NEXT_PUBLIC_GA_ENABLED,
  NEXT_PUBLIC_AMPLITUDE_API_KEY: process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY,
  NEXT_PUBLIC_AMPLITUDE_ENABLED: process.env.NEXT_PUBLIC_AMPLITUDE_ENABLED,
  NEXT_PUBLIC_AMPLITUDE_PROXY_URL: process.env.NEXT_PUBLIC_AMPLITUDE_PROXY_URL,
  NEXT_PUBLIC_CI_CD_IMAGE_NAME: process.env.NEXT_PUBLIC_CI_CD_IMAGE_NAME,
  NEXT_PUBLIC_TURNSTILE_ENABLED: process.env.NEXT_PUBLIC_TURNSTILE_ENABLED,
  NEXT_PUBLIC_TURNSTILE_SITE_KEY: process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY,
  NEXT_PUBLIC_TRACKING_ENABLED: process.env.NEXT_PUBLIC_TRACKING_ENABLED,
  NEXT_PUBLIC_GROWTH_CHANNEL_TRACKING_ENABLED: process.env.NEXT_PUBLIC_GROWTH_CHANNEL_TRACKING_ENABLED,
  NEXT_PUBLIC_UNLEASH_ENABLE_ALL: process.env.NEXT_PUBLIC_UNLEASH_ENABLE_ALL,
  NEXT_PUBLIC_HOSTED_LOGIN_ONLY: process.env.NEXT_PUBLIC_HOSTED_LOGIN_ONLY,
  NEXT_PUBLIC_SKIP_PAYMENT_METHOD_STEP: process.env.NEXT_PUBLIC_SKIP_PAYMENT_METHOD_STEP,
  NEXT_PUBLIC_GTM_ID: process.env.NEXT_PUBLIC_GTM_ID,
  NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY,
  NEXT_PUBLIC_BASE_TEMPLATES_URL: process.env.NEXT_PUBLIC_BASE_TEMPLATES_URL,
  NEXT_PUBLIC_MANAGED_WALLET_TRIAL_BLOCKED_GPU_MODELS: process.env.NEXT_PUBLIC_MANAGED_WALLET_TRIAL_BLOCKED_GPU_MODELS
});

export type BrowserEnvConfig = typeof browserEnvConfig;
